import * as types from '../actions/types';

const initialState = {
  data: {},
  rateList: [],
  users: [],
  isLoading: false,
  photos: {},
  selfPhoto: '',
  passwordError: null,
  scheduleToday: [],
};

export default function lk(state = initialState, action) {
  switch (action.type) {
    case types.LK_FETCH_COMPLETED:
      return {
        ...state,
        data: action.data,
      };
    case types.UNREAD_MESSAGE_FETCH_COMPLETED:
      return {
        ...state,
        unreadMessages: action.unreadMessages,
      };
    case types.CHATS_FETCH_COMPLETED:
      return {
        ...state,
        chats: action.chats,
      };
    case types.CHAT_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.CHAT_FETCH_COMPLETED:
      return {
        ...state,
        chat: action.chatInfo.chat,
        isLoading: false,
      };
    case types.USERS_FETCH_COMPLETED:
      return {
        ...state,
        users: action.data,
      };
    /* eslint-disable */
    case types.CHAT_MESSAGES_FETCH_COMPLETED:
      const treeMessages = action.messages.messages;
      treeMessages.map((elem,idx) => {treeMessages[idx].arr = [];});
      treeMessages.map(mess => action.messages.messages.map(mess2 => mess.id === mess2.parent ? mess.arr = [...mess.arr, mess2] : false));
      const filteredMessages = treeMessages.filter(elem => elem.parent === 0);
      return {
        ...state,
        messages: filteredMessages,
        treeMessages: filteredMessages,
        lineMessages: action.messages.messages,
      };
    /* eslint-enable */
    case types.LK_PHOTO_FETCH_COMPLETED:
      return {
        ...state,
        photo: action.photo,
      };
    case types.SELF_PHOTO:
      return {
        ...state,
        selfPhoto: action.photo,
      };
    case types.AUTH_FAILED:
      return {
        ...state,
        photo: null,
      };
    case types.SIGNED_OUT:
      return {
        ...state,
        photo: null,
      };
    case types.RATE_FETCH_COMPLETED:
      return {
        ...state,
        rateList: action.rateList,
      };
    case types.CHAT_PHOTOS_FETCHED: {
      const newPhotos = { ...state.photos };
      newPhotos[action.userId] = action.photo;
      return {
        ...state,
        photos: newPhotos,
      };
    }
    case types.UPDATE_PASSWORD_ERROR: {
      return {
        ...state,
        passwordError: action.passwordError,
      };
    }
    case types.PORTFOLIO_PRACTICE_FETCH_COMPLETED:
      return {
        ...state,
        practice: action.practice,
      };
    case types.LK_SCHEDULE_TODAY_FETCH_COMPLETED:
      return {
        ...state,
        scheduleToday: action.scheduleToday,
      };
    default:
      return state;
  }
}
